import { LocationEntity, Owner } from './location.types';

export enum ClientPaymentStatus {
  initiated = 'initiated',
  cancelled = 'cancelled',
  completed = 'completed',
  failed = 'failed',
  chargedBack = 'chargedBack',
}

export type ClientPaymentEntity = {
  id: number;
  status: ClientPaymentStatus;
  amount: number;
  fee: number;
  cancellationFee?: number | null;
  amountWithoutFees: number;
  paymentId?: string | null;
  createdAt: string;
  location: Pick<LocationEntity, 'id' | 'name'>;
  owner: Owner;
};
